import MultiAutosuggest from './MultiAutosuggest';

export default MultiAutosuggest;
